import React from "react";
import EventCard from "./EventCard";
import { normalizeExternalUrl } from "../urlUtils";

function formatPublishedDate(value) {
  if (!value) return "";
  const date = typeof value.toDate === "function" ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);
}

export default function CommunityFeedItem({ item }) {
  if (item.kind === "event") {
    return <EventCard event={item.event} variant="compact" />;
  }

  const fileUrl = normalizeExternalUrl(item.fileUrl);
  const publishedDate = formatPublishedDate(item.createdAt);

  return (
    <article
      data-content-type={item.kind}
      className="min-w-0 rounded-2xl border border-white/10 bg-white/5 p-4"
    >
      <div className="flex min-w-0 items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-[#F4A261]">
            {item.typeLabel}
          </p>
          <h3 className="mt-1 text-lg font-semibold">{item.title}</h3>
        </div>
        <span className="shrink-0 rounded-full border border-white/10 bg-white/10 px-2 py-1 text-xs">
          Update
        </span>
      </div>

      {item.description ? (
        <p className="mt-2 text-sm text-white/70">{item.description}</p>
      ) : null}

      {fileUrl ? (
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex items-center justify-center rounded-xl border border-white/10 bg-white/10 px-3 py-2 text-sm hover:bg-white/15"
        >
          View document
        </a>
      ) : null}

      {publishedDate ? (
        <p className="mt-4 text-xs text-white/50">Published {publishedDate}</p>
      ) : null}
    </article>
  );
}
